<template>
  <div class="contact">
    <div class="container">
      <div class="summary">
        <h3 class="title">联系我们</h3>
        <h4 class="e-title">CONTACT US</h4>
        <div id="map"></div>
        <el-row class="info-wrap">
          <el-col :xs="24" :sm="12">
            <div class="item">
              <div class="title">
                <i class="el-icon-location-information"></i>
                联系地址
              </div>
              <div class="info">湖北省武汉市洪山区梨园街道团结村龙潭大厦B1109</div>
            </div>
          </el-col>
          <el-col :xs="24" :sm="12">
            <div class="item">
              <div class="title">
                <i class="el-icon-phone-outline"></i>
                联系方式
              </div>
              <div class="info">电话: 027-88110977</div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { loadTMAP } from '@/utils'

export default {
  name: 'About',
  data() {
    return {
      map: null
    }
  },
  mounted() {
    this.initTmap()
  },
  beforeDestroy() {
    this.map && this.map.destroy()
  },
  methods: {
    async initTmap(e) {
      const TMap = await loadTMAP()
      var center = new TMap.LatLng(30.584236, 114.352052)
      this.map = new TMap.Map('map', {
        center: center,
        zoom: 17,
        pitch: 0, // 俯仰度
        rotation: 0 // 旋转角度
      })
      const markers = new TMap.MultiMarker({
        map: this.map,
        geometries: [
          {
            id: '1', //点标记唯一标识，后续如果有删除、修改位置等操作，都需要此id
            position: new TMap.LatLng(30.584236, 114.352052)
          }
        ]
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.contact {
  display: flex;
  justify-content: center;
  background: url('~@/assets/map-bg.png') no-repeat center;
  background-size: cover;
}
.container {
  display: flex;
  justify-content: center;
  .summary {
    flex: auto;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: calc(100vh - 100px);
    padding: 20px;
    box-sizing: border-box;
    .title {
      margin: 6px 0;
    }
    .e-title {
      margin: 10px 0;
    }
    .info-wrap {
      align-self: stretch;
      margin-top: 20px;
    }
  }
}
#map {
  width: 100%;
  height: 380px;
}

@media screen and (max-width: 1199px) {
  .container {
    width: 100%;
  }
  #map {
    height: 360px;
  }
}

@media screen and (min-width: 1200px) {
  .container {
    width: 1200px;
  }
}

@media screen and (max-width: 767px) {
  .container {
    .summary {
      height: auto;
    }
  }
  #map {
    width: 100%;
    height: 340px;
  }
}
</style>
